export const fabricationMachines = [
  { value: "Welding Machine", label: "Welding Machine" },

  {
    value: "Paint Compressor Machine",
    label: "Paint Compressor Machine",
  },
  {
    value: "CNC Router Machine",
    label: "CNC Router Machine",
  },
  {
    value: "Acrylic Laser Cutting Machine",
    label: "Acrylic Laser Cutting Machine",
  },
  {
    value: "Channel Letter Bending Machine",
    label: "Channel Letter Bending Machine ",
  },
];
export const printingMachines = [
  { value: "Ecosolvent Printing", label: "Ecosolvent Printing" },
  { value: "UV Printing", label: "UV Printing" },
  { value: "Digital Printing", label: "Digital Printing" },
  { value: "Solvent Printing", label: "Solvent Printing" },
  { value: "Plotter Cutting Printing", label: "Plotter Cutting Printing" },
  { value: "Latex Printing", label: "Latex Printing" },
];
export const combinedMachines = [...fabricationMachines, ...printingMachines];
